import React from 'react';
import {compose, graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {Card, Loading} from 'ui-kit';

import * as styles from './PlanDetail.module.css';

function PlanDetail({data}) {
  if (data == null || data.errors != null) {
    return (
      <Card>
        <p>An error occurred. Try refreshing this page or come back later.</p>
      </Card>
    );
  }

  if (data.loading) {
    return (
      <Card>
        <Loading />
      </Card>
    );
  }

  const plan = data.me.practice.membershipPlan;

  if (plan == null) {
    return (
      <Card>
        <p>We couldn't find that plan.</p>
      </Card>
    );
  }

  return (
    <Card>
      <h2 className={styles.Heading}>{plan.title}</h2>

      <p>{plan.description}</p>

      <h3 className={styles.Subheading}>Trackable benefits</h3>

      {plan.benefits.length > 0 ? (
        plan.benefits.map(benefit => (
          <div key={benefit.id} className={styles.Benefit}>
            <p>
              <strong>{benefit.name}</strong>
            </p>
            <p>
              <small>Quantity: {benefit.quantity}</small>
            </p>
          </div>
        ))
      ) : (
        <p>
          <small>This plan does not have any trackable benefits</small>
        </p>
      )}
    </Card>
  );
}

export default compose(
  graphql(
    gql`
      query PlanDetailQuery($id: ID!) {
        me {
          ... on StaffMember {
            id
            practice {
              id
              membershipPlan(id: $id) {
                id
                title
                description
                benefits {
                  id
                  name
                  quantity
                }
              }
            }
          }
        }
      }
    `,
    {
      options: props => ({
        variables: {id: props.id},
      }),
    },
  ),
)(PlanDetail);
